import { render, staticRenderFns } from "./KioskLinks.vue?vue&type=template&id=e90214ec&"
import script from "./KioskLinks.vue?vue&type=script&lang=js&"
export * from "./KioskLinks.vue?vue&type=script&lang=js&"
import style0 from "./KioskLinks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports